import { useRouteMatch } from 'react-router-dom';
import { ROUTER_ENTITY_TO_ROUTE_PATH_MAP } from '../../../../constants';

type AlertParams = {
  alertId?: string;
};

export const useSelectedAlertId = (): number | undefined => {
  // Using `useRouteMatch()` instead of `useParams()` since we're not always inside the Alert <Router>
  const match = useRouteMatch<AlertParams>(
    ROUTER_ENTITY_TO_ROUTE_PATH_MAP.alert,
  );

  const alertIdStr = match?.params.alertId;
  const parsedAlertId = parseInt(alertIdStr ?? '', 10);

  return Number.isNaN(parsedAlertId) ? undefined : parsedAlertId;
};
